export default __webpack_public_path__ + "static/media/cuba.4079ecf6.svg";